import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { clearReturnTo, readReturnTo } from '@/utils/return-to';

// WHY: when an authenticated user lands on `/` (the public entry — also where Auth0 returns after
// login), send them to the route they originally deep-linked to, else `/home`
// (TICKET-signin-onboarding-edge-cases #3). The target is read once on mount (so a StrictMode double
// render can't shift it) and the stash is cleared in an effect so it's consumed exactly once.
export function AuthenticatedEntryRedirect() {
  const [target] = useState(readReturnTo);

  useEffect(() => {
    clearReturnTo();
  }, []);

  return <Navigate to={target} replace />;
}
